/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useState } from "react";
/// ACTIONS ///
import { createShopAddon } from "api/actions/shop_quote";
import { updateShopAddon } from "api/actions/shop_quote";
/// TYPES ///
import { LineItemError } from "api/error_types/line_item_error";
import { IShopAddon } from "api/types/shop_quote/addon";
import { IShopQuote } from "api/types/shop_quote/quote";
/// MUI ///
import Box from "@mui/material/Box";
import { Dialog } from "@mui/material";
import { DialogActions } from "@mui/material";
import { DialogContent } from "@mui/material";
import { DialogTitle } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
/// COMPONENTS ///
import BaseButton from "components/universal/button/base";
/// ICONS ///
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
/// STYLES ///
import { dialog_body_style } from "styles/dialog";

interface Props {
  quote: IShopQuote,
  open: boolean,
  title: string,
  setOpen: (open: boolean) => void,
  item: IShopAddon,
  setItem: (item: IShopAddon) => void
}

export default function ShopSaveAddon({ quote, open, title, setOpen, item, setItem }: Props) {
  const dispatch = useAppDispatch();
  const [errors, setErrors] = useState<LineItemError>({});

  const setTaxable = (taxable: string) => {
    console.log(taxable);
    if (taxable === "Yes") {
      setItem({ ...item, taxable: true });
    }
    else {
      setItem({ ...item, taxable: false });
    }
  }

  const setShow = (taxable: string) => {
    if (taxable === "Yes") {
      setItem({ ...item, show: true });
    }
    else {
      setItem({ ...item, show: false });
    }
  }

  const save = () => {
    let e: LineItemError = {};

    if (!item.price) {
      e.price_error = "Price must be a valid number.";
      e.price_has_error = true;
    }

    if (!item.name || item.name === "") {
      e.name_error = "Must enter a name for this product.";
      e.name_has_error = true;
    }

    setErrors(e);

    if (e.price_has_error || e.name_has_error) {
      return;
    }

    if (item?.id) {
      dispatch(updateShopAddon({ ...item, quote: quote.id }));
    }
    else {
      dispatch(createShopAddon({ ...item, quote: quote.id }));
    }
    setItem({});
    setOpen(false);
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={dialog_body_style}>
        <Box display="flex" flexDirection="column" sx={{ gap: "10px", paddingTop: "10px" }}>
          <TextField
            label="Name"
            value={item?.name ?? ""}
            error={errors.name_has_error}
            helperText={errors.name_error}
            onChange={(e) => setItem({ ...item, name: e.target.value })} />
          <TextField
            type="number"
            label="Price($)"
            error={errors.price_has_error}
            helperText={errors.price_error}
            value={item?.price > 0 ? item.price : ""}
            onChange={(e) => setItem({ ...item, price: Number(e.target.value) })} />
          <TextField
            select
            label="Taxable"
            value={item?.taxable ? "Yes" : "No"}
            onChange={(e) => setTaxable(e.target.value)}>
            <MenuItem key="Yes" value="Yes">Yes</MenuItem>
            <MenuItem key="No" value="No">No</MenuItem>
          </TextField>
          <TextField
            select
            label="Show on Quote"
            value={item?.show ? "Yes" : "No"}
            onChange={(e) => setShow(e.target.value)}>
            <MenuItem key="Yes" value="Yes">Yes</MenuItem>
            <MenuItem key="No" value="No">No</MenuItem>
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <BaseButton text="Cancel" icon={faTimes} clickEvent={() => setOpen(false)} />
        <BaseButton text="Add" icon={faPlus} clickEvent={save} />
      </DialogActions>
    </Dialog>
  )
}
